import React, { FC } from 'react';
import dayjs from 'dayjs';

// Shared UI Library Components
import { CustomIcon, EIconName, Loader } from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './notification-item.scss';

// Models
import { INotificationItem } from '../../../../interfaces/notifications.interfaces';
import { EOwnerNotificationType } from '../../../../enums/notifications.enums';

type TNotificationItemProps = {
  notification: INotificationItem;
  loading?: boolean;
  onDelete?: (id: number) => void
  onView?: (notification: INotificationItem) => void
};

export const NotificationItem: FC<TNotificationItemProps> = (
  {
    notification,
    loading = false,
    onDelete = () => {},
    onView = () => {}
  }: TNotificationItemProps
) => {

  const getActionTextByType = (): string => {
    if (notification.notification_type === EOwnerNotificationType.Blocked) {
      return 'blocked';
    }
    if (notification.notification_type === EOwnerNotificationType.Reported) {
      return 'has reported';
    }
    return 'Refund Request from';
  }

  const onDeleteHandler = (): void => {
    if (loading) return;
    onDelete(notification.id);
  }

  const onViewHandler = (): void => {
    onView(notification);
  }

  return (
    <div className="notification-item">
      <div className="notification-item--info">
        <div className="info-item info-item--title">
          { notification.user.first_name } { notification.user.last_name } { getActionTextByType() }
          <span>{ notification.worker.first_name } { notification.worker.last_name }</span>
        </div>
        <div className="info-item info-item--date">
          { dayjs(notification.notification_created_at).format('DD MMM YYYY, hh:mm A') }
        </div>
      </div>
      <div className="notification-item--actions">
        <div className="actions-item actions-item--view">
          {/*<CustomButton text={ 'View' } type={ 'text' } size={ 'small' } onClick={ onViewHandler }/>*/}
        </div>
        <div className="actions-item actions-item--delete" onClick={ onDeleteHandler }>
          { loading ? <Loader/> : <CustomIcon name={ EIconName.Close }/> }
        </div>
      </div>
    </div>
  );
}
